import { menuListItems } from "assets/menu/menuList";
import { Menu } from "components/Menu";
import { Tab } from "components/Tab";
import { TabNav } from "components/TabNav";
import React from "react";
import { BaseRoutes } from "routes/BaseRoutes";
import { EventForm } from "../EventForm";
import { SponsorsTable } from "./ExhibitorsTable";
import { FaqsTable } from "./FaqsTable";
import { LocationsTable } from "./LocationsTable";
import { RegistrationsTable } from "./RegistrationsTable";
import { SessionsTable } from "./SessionsTable";
import { TracksTable } from "./TracksTable";

import { useSearchParam } from "hooks/useSearchParam";
import { useParams } from "react-router-dom";
import { useEventDetails } from "./useEventDetails";

const tabs = [
  "Dados do evento",
  "Inscrições",
  "Expositores",
  "Sessões",
  "FAQs",
  "Trilhas",
  "Locais",
];

export const EventDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { tab, setTab } = useSearchParam("tab");
  const selected = tab || tabs[0];

  const {
    handleInputChange,
    handleSelectChange,
    inputsValues,
    touched,
    errors,
    changeFooter,
    submitButton,
    handleSubmit,
    hasError,
    isLoading,
    customHandleImageChange,
    customHandlePdfChange,
  } = useEventDetails(id);

  return (
    <Menu links={menuListItems}>
      <TabNav
        tabs={tabs}
        selected={selected}
        setSelected={setTab}
        backPath={BaseRoutes.home}
      >
        <Tab isSelected={selected} tabName="Dados do evento">
          <EventForm
            handleChange={handleInputChange}
            inputsValues={inputsValues}
            touched={touched}
            errors={errors}
            handleSelectChange={handleSelectChange}
            changeFooter={changeFooter}
            handleSubmit={handleSubmit}
            submitButton={submitButton}
            hasError={hasError}
            isLoading={isLoading}
            isEditing={true}
            customHandleImageChange={customHandleImageChange}
            customHandlePdfChange={customHandlePdfChange}
          />
        </Tab>

        <Tab isSelected={selected} tabName="Inscrições">
          <RegistrationsTable />
        </Tab>

        <Tab isSelected={selected} tabName="Expositores">
          <SponsorsTable />
        </Tab>

        <Tab isSelected={selected} tabName="Sessões">
          <SessionsTable />
        </Tab>

        <Tab isSelected={selected} tabName="FAQs">
          <FaqsTable />
        </Tab>

        <Tab isSelected={selected} tabName="Trilhas">
          <TracksTable />
        </Tab>

        <Tab isSelected={selected} tabName="Locais">
          <LocationsTable />
        </Tab>
      </TabNav>
    </Menu>
  );
};
